
import Vue from "vue"
import Login from "@/components/Login.vue"

export default Vue.extend({
  components: {
    Login
  },
  data: () => ({
    show: true
  }),
  created() {
    document.title = this.$vuetify.lang.t("$vuetify.tab_titles.login")
  }
})
